import { createSelector } from '@reduxjs/toolkit';

//📌 Selector for get all categories from current profile.
export const selectDefaultCategories = createSelector(
	[(state) => state.DefaultCategories.data],
	(categoriesData) => categoriesData || []
);

//📌 Selector for get default category for ID
export const selectDefaultCategoryByID = createSelector(
	[(state) => state.DefaultCategories.data, (_, defaultCategoryID) => defaultCategoryID],
	(defaultCategoriesData, defaultCategoryID) =>
		(defaultCategoriesData || []).find((category) => category.categoryID === defaultCategoryID) || null
);

//📌 Selector for get default category icon for ID
export const selectDefaultCategoryIconByID = createSelector(
	[(state) => state.DefaultCategories.data, (_, defaultCategoryID) => defaultCategoryID],
	(defaultCategoriesData, defaultCategoryID) => {
		// If no default category ID, use a default icon
		const defaultCategoryIcon = 'defaultCategories/icon/defaultIcon.svg';

		return (
			(defaultCategoriesData || []).find((category) => category.categoryID === defaultCategoryID)?.icon ||
			defaultCategoryIcon
		);
	}
);

//📌 Selector for get marker icon URLs map for multiple category IDs
export const selectMarkerIconPathsMap = createSelector(
	[(state) => state.DefaultCategories.data, (_, categoryIds) => categoryIds],
	(defaultCategoriesData, categoryIds) => {
		const iconPathsMap = {};
		const defaultMarkerIcon = 'defaultCategories/markerIcon/defaultIcon.svg';
		
		categoryIds.forEach(categoryId => {
			const category = (defaultCategoriesData || []).find(cat => cat.categoryID === categoryId);
			iconPathsMap[categoryId] = category?.markerIcon || defaultMarkerIcon;
		});
		
		return iconPathsMap;
	}
);
